module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1123.58bce4a5.png";